<wf-dialog-content>
  <form
    [formGroup]="form"
    class="wf-peppol-reject-dialog__form"
    (ngSubmit)="submit()"
  >
    <wf-input-textarea
      formControlName="note"
      [rows]="3"
      [label]="'PEPPOL.REJECT_DIALOG.Note' | translate"
    />
    <wf-input-select
      withoutNullable
      formControlName="reason"
      [label]="'PEPPOL.REJECT_DIALOG.Reason' | translate"
      [options]="reasonOptions"
    />

    <wf-input-select
      withoutNullable
      formControlName="requiredAction"
      [label]="'PEPPOL.REJECT_DIALOG.RequiredAction' | translate"
      [options]="requiredActionOptions"
    />
  </form>
</wf-dialog-content>

<wf-dialog-actions>
  <button wui-stroked-button size="md" (click)="cancel()">
    {{ 'Cancel' | translate }}
  </button>

  <button wui-fill-button size="md" color="primary" (click)="submit()">
    {{ 'PEPPOL.REJECT_DIALOG.Submit' | translate }}
  </button>
</wf-dialog-actions>
